import React from 'react';
import classNames from 'classnames';
import { Check } from 'react-feather';
import { Text, TEXT_VARIANTS } from '../Typography';

const Connector = () => (
  <div className="w-110 border-top border-midnight-70 mb-24" />
);
export const Step = ({
  isActive = false,
  isComplete = false,
  onClick,
  index,
  label = '',
  last,
  disabled = false,
}) => {
  const circleClassNames = classNames('Stepper-position d-f ai-c jc-c', {
    'Stepper-position--active': isActive,
    'Stepper-position--complete': isComplete,
    'Stepper-position--nonActive': !isActive && !isComplete,
    'Stepper-position--disabled': disabled,
  });

  const baseClassNames = classNames('d-f ai-c', {
    'Stepper-disabled': disabled,
  });

  const textVariant = () => {
    if (isActive) return TEXT_VARIANTS.BODY_BOLD;
    if (disabled) return TEXT_VARIANTS.BODY_LIGHT;
    return TEXT_VARIANTS.BODY;
  };
  return (
    <div
      className={baseClassNames}
      role="button"
      data-testid={`step-${index}`}
      onClick={() => (disabled ? {} : onClick())}
      tabIndex={index}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className="d-f fd-c ai-c w-24">
        <div className={circleClassNames}>
          {isComplete ? (
            <Check className="c-white" size="17px" strokeWidth="3px" />
          ) : (
            index + 1
          )}
        </div>
        <Text className="Stepper-text" variant={textVariant()}>
          {label}
        </Text>
      </div>
      {!last && <Connector />}
    </div>
  );
};

const Stepper = ({ children }) => {
  // the whole stepper setup, can click on each step to go back to it
  const childrenArray = React.Children.toArray(children).filter(Boolean);
  const steps = childrenArray.map((step, index) => {
    return React.cloneElement(step, {
      index,
      last: index + 1 === childrenArray.length,
      ...step.props,
    });
  });
  return (
    <>
      <div className="d-f fd-r ai-c w-100">{steps}</div>
      {steps.map(step => {
        if (step.props.isActive) {
          return step.props.component;
        }
        return null;
      })}
    </>
  );
};
export default Stepper;
